// extracted by mini-css-extract-plugin
export default {"dialog-paper-root":"EntityPickerPopover_dialog-paper-root__B1hrZ","popover-paper-root":"EntityPickerPopover_popover-paper-root__6aSJT"};